import ApiHelper from '../../utils/apiHelper';

export const GET_MARKETS_REQUEST = 'markets/GET_MARKETS_REQUEST';
export const GET_MARKETS_SUCCESS = 'markets/GET_MARKETS_SUCCESS';
export const GET_MARKETS_FAILURE = 'markets/GET_MARKETS_FAILURE';

export const getMarkets = (userId) => dispatch => {
  dispatch({type: GET_MARKETS_REQUEST});
  return ApiHelper.get('/api/macro/markets/', null, null, true, {user: userId})
    .then(res => {
      dispatch({
        type: GET_MARKETS_SUCCESS,
        payload: res.data,
      });
    }).catch(err => {
      console.error(err);
      dispatch({
        type: GET_MARKETS_FAILURE,
      });
    });
};